var _path, _rect, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.498535 11.9563H46.7206V43.6868H0.498535V11.9563Z",
    fill: "#050794"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.498535 8.6394H46.7182V22.7393L23.1563 30.2299L0.498535 22.7393V8.6394Z",
    fill: "#FBAF1B",
    style: {
      mixBlendMode: "darken"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8821,
    y: 0.857422,
    width: 19.4526,
    height: 6.63397,
    fill: "#FBAF1B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6095,
    cy: 30.2299,
    r: 3.16834,
    fill: "#FBAF1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.11226d4029f2e9bf41cec5d38dbf802a.svg";
export { ForwardRef as ReactComponent };